import React from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../utils/Constants";
import { useTranslation } from "react-i18next";
import { removeLocalKey, clearUserSession } from "../../../utils/commonfunction";


function LogOut({onClose}) {
   const {t} = useTranslation()
  const navigate = useNavigate(); 
  const logOutUser = ()=>{
    clearUserSession();
    navigate('/');

    if (onClose) onClose();
    Swal.fire({
      icon: "success",
      text: "Logout Successfully ",
      ...SWAL_SETTINGS,
    });
  }
  return (
    <>
      <div className="text-center flex items-center justify-center flex-col gap-[15px]">
        <img src="/images/logout.png" />
        <div className="flex flex-col gap-[10px]">
          <h1 className="headings-h1 text-zinc-800">{t("logout")}</h1>
          <p className="body-lg text-gray-500">
            {t("Are_you_sure_to_logout")}
          </p>
        </div>
        <div className="flex items-center gap-[15px] w-full mt-[15px]">
          <button className="btn btn-outline flex-1" onClick={()=>logOutUser()}>{t("btn_yes")}</button>
          <button className="btn btn-pri flex-1" onClick={()=>{  if (onClose) onClose();}}>{t("btn_no")}</button>
        </div>
      </div>
    </>
  );
}

export default LogOut;
